export default "__VITE_ASSET__14004320__"